<script setup lang="ts">
/**
 * Singbac — Notice by Nominee Director (Section 386AL(1) 통지 · 명목이사임).
 * company/resident 단위 1부. 체크박스는 문서 고정값. 개인 지명자(nominator) = client_*.
 */
import CddVarField from './cdd/CddVarField.vue';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <p class="doc-p"><CddVarField field-key="resident_director_name" label="Nominee Director Name" /></p>
    <p class="doc-p"><CddVarField field-key="resident_director_address" label="Nominee Director Address" /></p>
    <p class="doc-p"><CddVarField field-key="notice_date" label="Notice Date" /></p>

    <p class="doc-p">
      <CddVarField field-key="company_name" label="Company Name" /> (the "Company")<br />
      <CddVarField field-key="registered_office_address" label="Registered Office Address" />
    </p>

    <p class="doc-p">Dear Sirs,</p>

    <div class="doc-sec-title">NOTIFICATION PURSUANT TO SECTION 386AL(1) OF THE COMPANIES ACT 1967</div>
    <p class="doc-p" style="text-align:center">- APPOINTMENT AS NOMINEE DIRECTOR</p>

    <p class="doc-p">In compliance with Section 386AL(1) of the Companies Act 1967, I hereby inform you that:</p>

    <p class="doc-p"><span class="cbx">☐</span> I am not acting as a nominee director in the Company.</p>
    <p class="doc-p"><span class="cbx">☒</span> I have been appointed as a nominee director in the Company by the following nominator:</p>

    <p class="doc-lbl-title">Particulars of Nominator (Individual)</p>
    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td>Full name of individual nominator</td>
          <td><CddVarField field-key="client_name" label="Client Name" /></td>
        </tr>
        <tr>
          <td>Aliases, if any</td>
          <td><CddVarField field-key="client_aliases" label="Client Aliases" /></td>
        </tr>
        <tr>
          <td>Residential address of individual nominator</td>
          <td><CddVarField field-key="client_address" label="Client Address" /></td>
        </tr>
        <tr>
          <td>Nationality of individual nominator</td>
          <td><CddVarField field-key="client_nationality" label="Client Nationality" /></td>
        </tr>
        <tr>
          <td>Identity card number or passport number of individual nominator</td>
          <td><CddVarField field-key="client_nric" label="Client NRIC / Passport" /></td>
        </tr>
        <tr>
          <td>Date of birth of individual nominator</td>
          <td><CddVarField field-key="client_dob" label="Client Date of Birth" /></td>
        </tr>
        <tr>
          <td>Date on which I became individual nominator's nominee</td>
          <td><CddVarField field-key="date_became_nominee" label="Date Became Nominee" /></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-p">Please make necessary entry into the Register of Nominee Directors of the Company.</p>

    <p class="doc-p"><i>*Signature page to follow</i></p>

    <p class="doc-p">Yours faithfully</p>
    <div class="sig-line">_________________________</div>
    <p class="doc-p"><CddVarField field-key="resident_director_name" label="Nominee Director Name" /></p>

    <p class="doc-p">
      Note: A director is a nominee if the director is accustomed or under an obligation whether formal or informal to act
      in accordance with the directions, instructions or wishes of any other person.
    </p>
  </div>
</template>

<style scoped>
.doc-lbl-title { font-weight: 800; margin: 14px 0 6px; }
.cbx { font-size: 15px; margin-right: 6px; }
.sig-line { font-family: monospace; margin-top: 18px; }
</style>
